/* eslint-disable import/prefer-default-export */

export const NOTIFICATION_SECTIONS = {
  task: 'Individual Tasks',
  'task-company': 'Company Tasks',
  cleaning: 'Supervised Cleaning',
  inspection: 'Supervised Inspection',
  maintenance: 'Supervised Maintenance',
  property: 'Property Alerts',
  messaging: 'Messaging Alerts',
  reservation: 'Reservation Alerts',
};

export const BASIC_NOTIFICATIONS = {
  'task/assignment': 'Task Assignment',
  'task/comment': 'Task Comment',
  'task/daily_digest': 'Daily Digest',
};
